import { ArabicEach, findRecursive } from '@/mm/utils.js'

export function washData(walkedNode) {
  let ArabicRule = [
    {
      flag: 'product_list_title',
      dataType: ['design','design'],
      onlyEnglish: ['title_textAlign', false],
      englishTitleLeft: ['left', 'self_marginLeft'],
      englishTitleRight: ['right', 'self_marginRight']
    },
    {
      flag: 'product_list_paragraph',
      dataType: ['design','design'],
      onlyEnglish: ['title_textAlign', false],
      englishTitleLeft: ['left', 'self_marginLeft'],
      englishTitleRight: ['right', 'self_marginRight']
    }
    // {
    //   flag: 'date_falg',
    //   dataType: ['design'],
    //   onlyEnglish: [false],
    //   englishTitleLeft: ['self_marginLeft'],
    //   englishTitleRight: ['self_marginRight']
    // }
  ]
  ArabicEach(walkedNode, ArabicRule)
}
